import { PasswordRequirementStrip } from "./PasswordRequirementStrip";

export default PasswordRequirementStrip;
